module.exports = __webpack_public_path__ + "media/images/covers/foundation/University-of-Birmingham-logo-048b13edf73ad93acdd7e64f5fba33da.svg";